var React = require('react');

function BypassGeoblocksIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.5 56C41.16 56 49 46.666 49 34s-7.84-22-16.5-22c-8.43 0-16.084 8.846-16.484 21H31a1 1 0 1 1 0 2H16.016c.4 12.154 8.054 21 16.484 21zm0-46c-9.96 0-18.08 10.209-18.484 23H1a1 1 0 1 0 0 2h13.016C14.42 47.791 22.54 58 32.5 58 42.717 58 51 47.255 51 34v1h13.586l-4.657 4.657a1 1 0 0 0 1.414 1.414l6.364-6.364a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 0 0-1.414 1.414L64.586 33H51v1c0-13.255-8.283-24-18.5-24z","fill":"#5FD800"}));
}

BypassGeoblocksIcon.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = BypassGeoblocksIcon;

BypassGeoblocksIcon.default = BypassGeoblocksIcon;
